// Phase 24c · Account billing history (light — payment method placeholder)
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, CreditCard } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
function eur(cents) { return `$${((cents || 0) / 100).toFixed(2)}`; }
function fmt(dt) { if (!dt) return ""; try { return new Date(dt).toLocaleString(); } catch { return dt; } }

export default function AccountBilling() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        document.title = "Billing · Global Lead Suite";
        (async () => {
            try {
                const r = await fetch(`${API}/api/subscriptions/me/billing-history?limit=50`, { credentials: "include" });
                if (r.ok) setItems(((await r.json()) || {}).items || []);
            } catch {}
        })();
    }, []);
    return (
        <div className="min-h-screen bg-[#0A0A0A] text-neutral-100">
            <div className="max-w-4xl mx-auto px-4 py-6">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-2xl font-bold" data-testid="account-billing-title">Billing history</h1>
                        <p className="text-xs text-neutral-500 mt-0.5">Invoices + payment method.</p>
                    </div>
                    <Link to="/account/subscriptions" className="text-xs text-[#CCCCCC] hover:underline">← My subscriptions</Link>
                </div>

                <div className="rounded-xl border border-[#1A1A1A] bg-[#111111] p-4 mb-4" data-testid="account-billing-payment-method">
                    <p className="text-xs text-neutral-500 uppercase tracking-widest mb-2">Payment method</p>
                    <div className="flex items-center gap-2 text-sm">
                        <CreditCard size={16} className="text-neutral-400" />
                        <span className="font-mono">•••• 4242 · Visa · exp 12/28</span>
                        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-neutral-500/15 text-neutral-300">MOCK</span>
                    </div>
                </div>

                <div className="rounded-xl border border-[#1A1A1A] bg-[#111111] overflow-x-auto" data-testid="account-billing-table">
                    <table className="w-full text-xs">
                        <thead className="text-left text-neutral-500 border-b border-[#1A1A1A]">
                            <tr>
                                <th className="px-3 py-2">Date</th>
                                <th className="px-3 py-2">Payment ID</th>
                                <th className="px-3 py-2">Amount</th>
                                <th className="px-3 py-2">Status</th>
                                <th className="px-3 py-2">Invoice</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((p) => (
                                <tr key={p.stripe_id} className="border-b border-[#1A1A1A]">
                                    <td className="px-3 py-2 text-neutral-500">{fmt(p.created_at)}</td>
                                    <td className="px-3 py-2 font-mono text-[10px] text-neutral-400 truncate max-w-[200px]">{p.stripe_id}</td>
                                    <td className="px-3 py-2">{eur(p.amount_cents)}</td>
                                    <td className="px-3 py-2 capitalize">{p.status}</td>
                                    <td className="px-3 py-2"><span className="inline-flex items-center gap-1 text-[10px] text-neutral-500"><FileText size={10} /> PDF (soon)</span></td>
                                </tr>
                            ))}
                            {items.length === 0 && (
                                <tr><td colSpan="5" className="px-3 py-6 text-center text-neutral-500">No invoices yet</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
